import { render } from "./DetailedTaskDialog.vue?vue&type=template&id=08c63bf4&scoped=true"
import script from "./DetailedTaskDialog.vue?vue&type=script&lang=js"
export * from "./DetailedTaskDialog.vue?vue&type=script&lang=js"

import "./DetailedTaskDialog.vue?vue&type=style&index=0&id=08c63bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c63bf4"]])

export default __exports__